import { ActionTypes, DEFAULT_APP_CHANNEL } from '../constants/AppConstants';
import BaseStore from './BaseStore';
import FeatureFlagStore from './FeatureFlagStore';

export class InAppStore extends BaseStore {

    getActionHandlers () {
        return {
            [ActionTypes.IN_APP_SESSION_STARTED]: this.handleSessionStarted,
            [ActionTypes.AUTH_REFRESHED]: this.handleAuthRefresh,
            [ActionTypes.LOGGED_IN]: this.handleAuthRefresh,
            [ActionTypes.USER_UPDATED]: this.handleAuthRefresh,
            [ActionTypes.LOGGED_OUT]: this.handleLogout,
            [ActionTypes.MOBILE_APP_RATING_TRIGGERED]: this.handleMobileAppRating,
            [ActionTypes.MOBILE_APP_RE_ORDER]: this.handleReorder,
            [ActionTypes.SET_IN_APP]: this.setInApp,
        };
    }

    isInApp () {
        return FeatureFlagStore.get('enableInAppMode') || this.state.get('inApp');
    }

    setInApp ({ value }) {
        this.setState(this.state.set('inApp', value));
    }

    getChannel () {
        return this.state.get('channel', DEFAULT_APP_CHANNEL);
    }

    disableAutoLogout () {
        return this.state.get('disableAutoLogout', false);
    }

    disableAccountNavigationLogout () {
        return this.state.get('disableAccountNavigationLogout', false);
    }

    getAppVersion () {
        return this.state.get('appVersion');
    }

    handleSessionStarted ({
        appVersion,
        channel = DEFAULT_APP_CHANNEL,
        disableAutoLogout = false,
        disableAccountNavigationLogout = false
    } = {}) {
        const state = this.state.merge({
            appVersion,
            channel,
            disableAutoLogout,
            disableAccountNavigationLogout,
            inApp: true
        });
        this.setState(state);
    }

    /**
     * Crucial for keeping the app authenticated
     */
    handleAuthRefresh () {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                source: 'otrl',
                event: 'auth-refreshed',
            }));
        }
    }

    handleLogout () {
        if (this.isInApp() && window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                source: 'otrl',
                event: 'auth-logout',
            }));
        }
    }

    handleMobileAppRating () {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                source: 'otrl',
                event: 'rate-app',
            }));
        }
    }

    handleReorder (params) {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                source: 'otrl',
                event: 're-order',
                data: params
            }));
        }
    }
}

const storeInstance = new InAppStore({ storageKey: 'inApp' });

export default storeInstance;
